import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/Layout';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { del, get, post, put } from '../../controllers/apiController';
import * as XLSX from 'xlsx';
import { Select2, Select2WColor } from '../../components/Select2';
import { normalizeLeadInfo } from '../../utils/leadUtils';

import $ from 'jquery';
import Swal from 'sweetalert2';

const FormDetay = () => {
    const [searchParams] = useSearchParams();
    const [formData, setFormData] = useState({
        LeadInfo: {
            Adi_Soyadi: '',
            E_Posta: '',
            Telefon: '',
            Mesaj: '',
            UTM: '',
            Tarih: '',
            IP: '',
            Kaynak: '',
            Aciklama: '',
            Kampanya: null,
            Gorsel: ''
        },
        Hatirlatma_Tarihi: null,
        Etiketler: [],
        Temsilci_Isim: '',
        Temsilci_Profil: null
    });

    const [isLoading, setIsLoading] = useState(true);

    const [notes, setNotesData] = useState([]);
    const [temsilciler, setTemsilciler] = useState([]);
    const [etiketler, setEtiketler] = useState([]);

    const [selectedNote, setSelectedNote] = useState(null);

    const [formID] = useState(searchParams.get("id"));

    const addNoteRef = useRef(null);
    const editAciklamaRef = useRef(null);
    const editReminderRef = useRef(null);
    const editTemsilciRef = useRef(null);
    const addEtiketRef = useRef(null);
    const viewNoteRef = useRef(null);

    const temsilciSelectRef = useRef(null);
    const etiketSelectRef = useRef(null);

    const [yeniAciklama, setYeniAciklama] = useState('');
    const [reminderDate, setReminderDate] = useState('');

    const [newEtiket, setNewEtiket] = useState(null);

    const [noteTitle, setNoteTitle] = useState('');
    const [noteDesc, setNoteDesc] = useState('');

    const formatToDateTimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    function formatFieldLabel(text) {
        return text
            .replaceAll("_", " ")
            .replace(/\?/g, " ?")
            .replace(/\s+/g, " ")
            .trim()
            .split(" ")
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(" ");
    }

    useEffect(() => {
        const getFormData = async () => {
            try {
                const res = await get(`forms/${formID}`);
                if (res) {
                    const normalized = normalizeLeadInfo(res);
                    setFormData(normalized);
                    setNotesData(normalized.Notlar);
                    setYeniAciklama(normalized.LeadInfo.Aciklama);
                    setReminderDate(formatToDateTimeLocal(normalized.Hatirlatma_Tarihi));

                    document.title = `Form - ${res.LeadInfo.Adi_Soyadi} | LEVELUP CRM`;
                } else {
                    document.title = "Bulunamadı | LEVELUP CRM";
                }
            } catch (error) {
                toast.error("Form bilgileri yüklenirken hata oluştu");
            }

        }

        const getTemsilcilerData = async () => {
            try {
                const res = await get("users/company-users");

                const temsilcilerMapped = res.map(temsilci => {
                    return {
                        value: temsilci.Kullanici_ID,
                        label: `${temsilci.Kullanici_Adi} ${temsilci.Kullanici_Soyadi}`
                    }
                });

                setTemsilciler(temsilcilerMapped);
            } catch (err) {
                toast.error("Temsilci verileri alınırken bir hata oluştu!");
            }
        }

        const getEtiketlerData = async () => {
            try {
                const res = await get("labels/");

                const etiketlerMapped = res.map(etiket => {
                    return {
                        value: etiket.Etiket_ID,
                        label: etiket.Etiket_Adi,
                        color: "#" + etiket.Etiket_Renk
                    }
                });

                setEtiketler(etiketlerMapped);
            } catch (err) {
                toast.error("Etiket verileri alınırken bir hata oluştu!");
            }
        }

        const getAllData = async () => {
            await Promise.all([getFormData(), getTemsilcilerData(), getEtiketlerData()]);

            setIsLoading(false);
        }

        if (formID) {
            getAllData();
        }

    }, [formID]);

    useEffect(() => {
        // Modal açıldığında body'deki modal-open class'ını kaldır
        const removeModalOpenClass = () => {
            document.body.classList.remove('modal-open');
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0';
        };

        // Modal eventlerini dinle
        const addNoteModal = document.getElementById('addNote');
        const editAciklamaModal = document.getElementById('editAciklama');
        const editReminderModal = document.getElementById('editReminder');
        const editTemsilciModal = document.getElementById('editTemsilci');
        const addEtiketModal = document.getElementById('addEtiket');
        const viewNoteModal = document.getElementById('viewNote');

        addNoteModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editAciklamaModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editTemsilciModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        editReminderModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        addEtiketModal?.addEventListener('shown.bs.modal', removeModalOpenClass);
        viewNoteModal?.addEventListener('shown.bs.modal', removeModalOpenClass);

        return () => {
            // Cleanup
            addNoteModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editAciklamaModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editReminderModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            editTemsilciModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            addEtiketModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
            viewNoteModal?.removeEventListener('shown.bs.modal', removeModalOpenClass);
        };
    }, []);

    const createNote = async () => {
        if (noteTitle == "" || noteDesc == "") {
            toast.error("Tüm alanlar doldurulmalıdır!");
            return;
        }

        try {
            const response = await post('forms/note', {
                formID: formID,
                title: noteTitle,
                desc: noteDesc
            });

            setNotesData([...notes, response]);

            addNoteRef.current.querySelector('[data-bs-dismiss="modal"]').click();

            setNoteTitle("");
            setNoteDesc("");

            toast.success("Not başarıyla oluşturuldu.");
        } catch (err) {
            console.error(err);
            toast.error(err.response.data.message || "Bilinmeyen bir hata oluştu!");
        }
    }

    const deleteNote = async (noteID) => {
        console.log(noteID);
        Swal.fire({
            title: 'Notu silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/note/${noteID}`);

                    setNotesData(notes.filter((not) => not.Not_ID != noteID));

                    toast.success("Not başarıyla silindi.");
                } catch (err) {
                    toast.error(err.response.data.message);
                }
            }
        });
    }

    const viewNote = async (noteID) => {
        const noteData = notes.find((not) => not.Not_ID == noteID);

        setSelectedNote(noteData);
    }

    useEffect(() => {
        if (selectedNote != null) {
            const viewNoteDesc = document.getElementById("viewNoteDesc");

            viewNoteDesc.style.height = 'auto';
            viewNoteDesc.style.height = viewNoteDesc.scrollHeight + 'px';
        }
    }, [selectedNote]);

    const formatTarih = (dateStr) => {
        if (!dateStr) return '-';

        // ISO gelirse temizle
        const clean = dateStr
            .replace('T', ' ')
            .replace('Z', '')
            .split('.')[0];

        const [date, time] = clean.split(' ');
        if (!time) return '-';

        const [year, month, day] = date.split('-');
        const [hour, minute] = time.split(':');

        return `${day}.${month}.${year} ${hour}:${minute}`;
    };

    const handlePrint = () => {
        const printContent = `
            FORM BİLGİLERİ
            
            Kişisel Bilgiler:
            
            Adı Soyadı: ${formData.LeadInfo.Adi_Soyadi}
            E-Posta: ${formData.LeadInfo.E_Posta}
            Telefon: ${formData.LeadInfo.Telefon}
            Mesaj: ${formData.LeadInfo.Mesaj}
            
            Form Detayları:

            UTM Kaynak: ${formData.LeadInfo.UTM_Source || 'Boş'}
            UTM Medium: ${formData.LeadInfo.UTM_Medium || 'Boş'}
            UTM Reklam Grubu: ${formData.LeadInfo.UTM_Reklam_Grubu || 'Boş'}
            UTM Kampanya: ${formData.LeadInfo.UTM_Campaign || 'Boş'}
            UTM Kelime: ${formData.LeadInfo.UTM_Kelime || 'Boş'}
            Tarih: ${formatTarih(formData.LeadInfo.Tarih)}
            Kaynak: ${formData.LeadInfo.Kaynak}
            IP: ${formData.LeadInfo.IP || 'Belirtilmemiş'}
            
            Diğer Bilgiler:
            
            Temsilci: ${formData.Temsilci_Isim}
            Etiketler: ${formData.Etiketler.map(etiket => etiket.Etiket_Adi).join(', ')}
            Açıklama: ${formData.LeadInfo.Aciklama || 'Belirtilmemiş'}
        `;

        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
            <html>
                <head>
                    <title>Form Detayı - ${formData.LeadInfo.Adi_Soyadi}</title>
                    <style>
                        body { font-family: Arial, sans-serif; line-height: 1.6; padding: 20px; }
                        pre { white-space: pre-wrap; }
                    </style>
                </head>
                <body>
                    <pre>${printContent}</pre>
                </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.print();
    };

    const handleExport = () => {
        const exportData = [{
            'Adı Soyadı': formData.LeadInfo.Adi_Soyadi,
            'E-Posta': formData.LeadInfo.E_Posta,
            'Telefon': formData.LeadInfo.Telefon,
            'Mesaj': formData.LeadInfo.Mesaj,
            'UTM Kaynak': formData.LeadInfo.UTM_Source || 'Boş',
            'UTM Medium': formData.LeadInfo.UTM_Medium || 'Boş',
            'UTM Reklam Grubu': formData.LeadInfo.UTM_Reklam_Grubu || 'Boş',
            'UTM Kampanya': formData.LeadInfo.UTM_Campaign || 'Boş',
            'UTM Kelime': formData.LeadInfo.UTM_Kelime || 'Boş',
            'Tarih': formatTarih(formData.LeadInfo.Tarih),
            'Kaynak': formData.LeadInfo.Kaynak,
            'IP': formData.LeadInfo.IP || 'Belirtilmemiş',
            'Temsilci': formData.Temsilci_Isim == "null null" ? "" : formData.Temsilci_Isim,
            'Etiketler': formData.Etiketler.map(etiket => etiket.Etiket_Adi).join(', '),
            'Açıklama': formData.LeadInfo.Aciklama || 'Belirtilmemiş'
        }];

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Form Detay");
        XLSX.writeFile(wb, `Form_${formData.LeadInfo.Adi_Soyadi}_${new Date().toLocaleDateString()}.xlsx`);
    };

    const handleReminderUpdate = async () => {
        try {
            await put(`forms/change-reminder`, {
                formID: formID,
                reminderDate: reminderDate
            });

            setFormData(prev => ({
                ...prev,
                Hatirlatma_Tarihi: reminderDate
            }));

            toast.success("Hatırlatma tarihi başarıyla güncellendi");

            editReminderRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Hatırlatma tarihi güncellenirken hata oluştu");
        }
    };

    const deleteReminder = async () => {
        try {
            await put(`forms/change-reminder`, {
                formID: formID
            });

            setFormData(prev => ({
                ...prev,
                Hatirlatma_Tarihi: null
            }));
            toast.success("Hatırlatma tarihi başarıyla kaldırıldı");

            editReminderRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Hatırlatma tarihi kaldırılırken hata oluştu");
        }
    }

    const handleAciklamaUpdate = async () => {
        try {
            await put(`forms/change-description`, {
                formID: formID,
                description: yeniAciklama.trim()
            });

            setFormData(prev => ({
                ...prev,
                LeadInfo: {
                    ...prev.LeadInfo,
                    Aciklama: yeniAciklama.trim()
                }
            }));
            toast.success("Açıklama başarıyla güncellendi");

            editAciklamaRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error("Açıklama güncellenirken hata oluştu");
        }
    };

    const changeTemsilci = async () => {
        try {
            await put("forms/change-user", {
                formID: formID,
                userID: temsilciSelectRef.current.value
            });

            const userData = await get(`users/company-users/${temsilciSelectRef.current.value}`);

            setFormData(prevFormData => ({
                ...prevFormData,
                Temsilci_ID: userData.Kullanici_ID,
                Temsilci_Isim: `${userData.Kullanici_Adi} ${userData.Kullanici_Soyadi}`,
                Temsilci_Profil: userData.Profil_Gorseli
            }));

            toast.success("Temsilci başarıyla değiştirildi.");

            editTemsilciRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error(error.response.data.message || "Temsilci değiştirilirken bir hata oluştu!");
        }
    }

    const deleteTemsilci = async () => {
        try {
            await put("forms/change-user", {
                formID: formID,
                userID: null
            });

            setFormData(prevFormData => ({
                ...prevFormData,
                Temsilci_ID: null,
                Temsilci_Isim: `null null`,
                Temsilci_Profil: null
            }));

            toast.success("Temsilci başarıyla kaldırıldı.");
        } catch (error) {
            toast.error(error.response.data.message || "Temsilci kaldırılırken bir hata oluştu!");
        }
    }

    const addEtiket = async () => {
        try {
            const labelData = await put("forms/add-label", {
                formID: formID,
                labelID: newEtiket.value
            });

            setFormData(prevFormData => ({
                ...prevFormData,
                Etiketler: [...prevFormData.Etiketler, {
                    Etiket_ID: newEtiket.value,
                    Etiket_Adi: labelData.Etiket_Adi,
                    Etiket_Renk: labelData.Etiket_Renk,
                    Etiket_Yazi_Renk: labelData.Etiket_Yazi_Renk
                }]
            }));

            toast.success("Etiket başarıyla eklendi.");
            addEtiketRef.current.querySelector('[data-bs-dismiss="modal"]').click();
        } catch (error) {
            toast.error(error.response.data.message || "Etiket eklenirken bir hata oluştu!");
        }
    }

    const deleteEtiket = async (labelId) => {
        Swal.fire({
            title: 'Etiketi silmek istediğinize emin misiniz?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`forms/delete-label`, {
                        formID: formID,
                        labelID: parseInt(labelId)
                    });

                    setFormData({
                        ...formData,
                        Etiketler: formData.Etiketler.filter((etiket) => etiket.Etiket_ID != labelId)
                    });

                    toast.success("Etiket başarıyla silindi.");
                } catch (err) {
                    toast.error(err.response.data.message || "Etiket silinirken bir hata oluştu!");
                }
            }
        });
    }

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">

                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./dashboard">Anasayfa</a></li>
                                <li className="breadcrumb-item"><a href="./forms">Formlar</a></li>
                                <li className="breadcrumb-item">Detay</li>
                            </ul>
                        </div>
                        <div className="page-header-right ms-auto">
                            <div className="page-header-right-items">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-header-right-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                                    <a href="javascript:void(0);"
                                        onClick={handlePrint}
                                        className="btn btn-icon btn-light-brand">
                                        <i className="feather-printer"></i>
                                    </a>
                                    <a href="javascript:void(0);"
                                        onClick={handleExport}
                                        className="btn btn-icon btn-light-brand">
                                        <i className="feather-file-text"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="d-md-none d-flex align-items-center">
                                <a href="javascript:void(0)" className="page-header-right-open-toggle">
                                    <i className="feather-align-right fs-20"></i>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white py-3 border-bottom rounded-0 p-md-0 mb-0">
                        <div className="d-md-none d-flex">
                            <a href="javascript:void(0)" className="page-content-left-open-toggle">
                                <i className="feather-align-left fs-20"></i>
                            </a>
                        </div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="nav-tabs-wrapper page-content-left-sidebar-wrapper">
                                <div className="d-flex d-md-none">
                                    <a href="javascript:void(0)" className="page-content-left-close-toggle">
                                        <i className="feather-arrow-left me-2"></i>
                                        <span>Geri</span>
                                    </a>
                                </div>
                                <ul className="nav nav-tabs nav-tabs-custom-style" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#infoTab">Bilgiler</button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#notesTab">Notlar</button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="tab-content">
                            <div className="tab-pane fade active show" id="infoTab" role="tabpanel">
                                {isLoading ? (
                                    <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">Yükleniyor...</span>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card card-body lead-info">
                                            <div className="mb-4 d-flex align-items-center justify-content-between">
                                                <h5 className="fw-bold mb-0">
                                                    <span className="d-block mb-2">Form Bilgileri:</span>
                                                </h5>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Adı Soyadı</div>
                                                <div className="col-lg-10">
                                                    <a href="javascript:void(0);">{formData.LeadInfo.Adi_Soyadi}</a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Email</div>
                                                <div className="col-lg-10"><a href="javascript:void(0);">{formData.LeadInfo.E_Posta}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Telefon</div>
                                                <div className="col-lg-10 d-flex justify-content-start align-items-center">
                                                    <a href={`tel:${formData.LeadInfo.Telefon}`}>{formData.LeadInfo.Telefon}</a>
                                                    <a href={`https://wa.me/${formData.LeadInfo.Telefon}`} target="_blank" className="btn btn-success rounded-circle ms-2 p-1" style={{ width: '30px', height: '30px' }}><i className="bi bi-whatsapp"></i></a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Mesaj</div>
                                                <div className="col-lg-10 fw-semibold">{formData.LeadInfo.Mesaj}</div>
                                            </div>
                                            {formData.LeadInfo.Ek_Alanlar && 
                                                Object.entries(formData.LeadInfo.Ek_Alanlar).map(([key, value]) => (
                                                    <div className="row mb-4" key={key}>
                                                        <div className="col-lg-2 fw-medium">{formatFieldLabel(key)}</div>
                                                        <div className="col-lg-9">
                                                            <a href="javascript:void(0);">{value ?? "Boş"}</a>
                                                        </div>
                                                    </div>
                                                ))
                                            }
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">UTM Kaynak</div>
                                                <div className="col-lg-9"><a href="javascript:void(0);">{formData.LeadInfo.UTM_Source == null ? "Boş" : formData.LeadInfo.UTM_Source}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">UTM Reklam Grubu</div>
                                                <div className="col-lg-9"><a href="javascript:void(0);">{formData.LeadInfo.UTM_Reklam_Grubu == null ? "Boş" : formData.LeadInfo.UTM_Reklam_Grubu}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">UTM Medium</div>
                                                <div className="col-lg-9"><a href="javascript:void(0);">{formData.LeadInfo.UTM_Medium == null ? "Boş" : formData.LeadInfo.UTM_Medium}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">UTM Kampanya</div>
                                                <div className="col-lg-9"><a href="javascript:void(0);">{formData.LeadInfo.UTM_Campaign == null ? "Boş" : formData.LeadInfo.UTM_Campaign}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">UTM Kelime</div>
                                                <div className="col-lg-9"><a href="javascript:void(0);">{formData.LeadInfo.UTM_Kelime == null ? "Boş" : formData.LeadInfo.UTM_Kelime}</a></div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Tarih</div>
                                                <div className="col-lg-10"><a href="javascript:void(0);">{formatTarih(formData.LeadInfo.Tarih)}</a></div>
                                            </div>
                                            {formData.LeadInfo.Kampanya && (
                                                <>
                                                    <div className="row mb-4">
                                                        <div className="col-lg-2 fw-medium">Kampanya</div>
                                                        <div className="col-lg-10 fw-semibold">{formData.LeadInfo.Kampanya}</div>
                                                    </div>
                                                    <div className="row mb-4">
                                                        <div className="col-lg-2 fw-medium">Kampanya Görseli</div>
                                                        <div className="col-lg-10">
                                                            <img src={formData.LeadInfo.Gorsel} width={75} />
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                        <hr />
                                        <div className="card card-body general-info">
                                            <div className="mb-4 d-flex align-items-center justify-content-between">
                                                <h5 className="fw-bold mb-0">
                                                    <span className="d-block mb-2">Genel Bilgiler:</span>
                                                </h5>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Kaynak</div>
                                                <div className="col-lg-10 hstack gap-1">
                                                    <a href="javascript:void(0);" className="hstack gap-2">
                                                        <div className="avatar-text avatar-sm">
                                                            <i className={`feather-${(formData.LeadInfo.Kaynak.toLowerCase() == 'meta' ? 'facebook' : (formData.LeadInfo.Kaynak.toLowerCase() == 'ads' ? 'google' : 'globe'))}`}></i>
                                                        </div>
                                                        <span>{formData.LeadInfo.Kaynak}</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">IP Adresi</div>
                                                <div className="col-lg-10 hstack gap-1">
                                                    <a href="javascript:void(0);" className="hstack gap-2">
                                                        <div className="avatar-text avatar-sm">
                                                            <i className="feather-globe"></i>
                                                        </div>
                                                        <span>{formData.LeadInfo.IP == null ? "Boş" : formData.LeadInfo.IP}</span>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Hatırlatma Tarihi</div>
                                                <div className="col-lg-10 hstack gap-1">
                                                    <a href="javascript:void(0);" className="hstack gap-2">
                                                        <span>{formData.Hatirlatma_Tarihi && new Date(formData.Hatirlatma_Tarihi).toLocaleString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).replace(',', '')}</span>
                                                        <button
                                                            className="text-primary border-0 bg-transparent p-0"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#editReminder"
                                                        >
                                                            <i className="feather-edit" style={{ fontSize: '14px' }}></i>
                                                        </button>
                                                        <button
                                                            className="text-primary border-0 bg-transparent p-0"
                                                            onClick={deleteReminder}
                                                        >
                                                            <i className="feather-trash-2" style={{ fontSize: '14px' }}></i>
                                                        </button>
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Temsilci</div>
                                                <div className="col-lg-10 hstack gap-1">
                                                    <div href="javascript:void(0);" className="hstack gap-2">
                                                        {formData.Temsilci_Profil != null && <img src={formData.Temsilci_Profil} className="avatar avatar-sm" />}
                                                        <span className="fw-semibold text-dark">{formData.Temsilci_Isim == "null null" ? "" : formData.Temsilci_Isim}</span>
                                                        <button
                                                            className="text-primary border-0 bg-transparent p-0"
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#editTemsilci"
                                                        >
                                                            <i className="feather-edit" style={{ fontSize: '14px' }}></i>
                                                        </button>
                                                        <button
                                                            className="text-primary border-0 bg-transparent p-0"
                                                            onClick={deleteTemsilci}
                                                        >
                                                            <i className="feather-trash-2" style={{ fontSize: '14px' }}></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Etiketler</div>
                                                <div className="col-lg-10 hstack gap-2">
                                                    {formData.Etiketler.map((etiket, index) => (
                                                        <a href="javascript:void(0);" onClick={(e) => deleteEtiket(etiket.Etiket_ID)} className="badge" style={{ backgroundColor: "#" + etiket.Etiket_Renk, color: "#" + etiket.Etiket_Yazi_Renk }}>
                                                            {etiket.Etiket_Adi}
                                                        </a>
                                                    ))}
                                                    <button
                                                        className="avatar-text avatar-sm"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#addEtiket"
                                                    >
                                                        <i className="feather-plus" style={{ fontSize: '14px' }}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mb-4">
                                                <div className="col-lg-2 fw-medium">Açıklama</div>
                                                <div className="col-lg-10 hstack gap-1">
                                                    {formData.LeadInfo.Aciklama}
                                                    <button
                                                        className="text-primary border-0 bg-transparent p-0"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editAciklama"
                                                    >
                                                        <i className="feather-edit" style={{ fontSize: '14px' }}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <div className="tab-pane fade" id="notesTab" role="tabpanel">
                                <div className="card card-body">
                                    <div class="row note-has-grid" id="note-full-container">
                                        {notes.length > 0 ? (
                                            <>
                                                {notes.map((not, index) => (
                                                    <div key={"note_" + not.Not_ID} className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                        <div className="card card-body mb-4 stretch stretch-full">
                                                            <span className="side-stick"></span>
                                                            <button onClick={(e) => viewNote(not.Not_ID)} data-bs-toggle="modal" data-bs-target="#viewNote" className="avatar-text avatar-md" style={{ position: 'absolute', right: '15px', top: '15px' }}><i className="feather-eye"></i></button>
                                                            <h5 className="note-title text-truncate w-75 mb-1" data-noteheading={not.Not_Basligi}>{not.Not_Basligi}</h5>
                                                            <p className="fs-11 text-muted note-date">{not.Not_Tarihi}</p>
                                                            <div className="note-content flex-grow-1">
                                                                <p className="text-muted note-inner-content text-truncate-3-line" data-notecontent={not.Not_Aciklamasi}>{not.Not_Aciklamasi}</p>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-1">
                                                                <button onClick={(e) => deleteNote(not.Not_ID)} className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                                <div className="ms-auto d-flex gap-2 align-items-center">
                                                                    <img src={not.Kullanici.Profil_Gorseli} className="avatar avatar-sm" />
                                                                    <span className="fw-bold">{not.Kullanici.Kullanici_Adi} {not.Kullanici.Kullanici_Soyadi}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                <div className="col-xxl-4 col-xl-6 col-lg-4 col-sm-6 single-note-item all-category note-important note-tasks">
                                                    <div className="card card-body mb-4 strech strech-full">
                                                        <span className="side-stick"></span>
                                                        <h5 className="note-title text-truncate w-75 mb-1" data-noteheading=""></h5>
                                                        <p className="fs-11 text-muted note-date"></p>
                                                        <div className="note-content flex-grow-1">
                                                            <p className="text-muted note-inner-content text-truncate-3-line" data-notecontent=""></p>
                                                        </div>
                                                        <p></p>
                                                        <a href="javascript:void(0);" className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-toggle="modal" data-bs-target="#addNote" data-bs-tooltip="tooltip" title="Yeni Not">
                                                            <i className="feather-plus"></i>
                                                        </a>
                                                        <span></span>
                                                        <div className="d-flex align-items-center gap-1 invisible pe-none">
                                                            <button className="avatar-text avatar-md"><i className="feather-trash-2 remove-note"></i></button>
                                                            <div className="ms-auto d-flex gap-2 align-items-center">
                                                                <img src="" className="avatar avatar-sm" />
                                                                <span className="fw-bold">LEVELUP CRM</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100vh - 315px)" }}>
                                                <div className="text-center">
                                                    <h2 className="fs-16 fw-semibold">Not bulunamadı!</h2>
                                                    <p className="fs-12 text-muted">Henüz herhangi bir not kayıt edilmemiş.</p>
                                                    <a href="javascript:void(0);" className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-toggle="modal" data-bs-target="#addNote" data-bs-tooltip="tooltip" title="Yeni Not">
                                                        <i className="feather-plus"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="commentTab" role="tabpanel">
                                <div className="card card-body">
                                    <div className="d-flex align-items-center justify-content-center" style={{ height: "calc(100vh - 315px)" }}>
                                        <div className="text-center">
                                            <h2 className="fs-16 fw-semibold">No comments yet!</h2>
                                            <p className="fs-12 text-muted">There is no comments posted yet.</p>
                                            <a href="javascript:void(0);" className="avatar-text bg-soft-primary text-primary mx-auto" data-bs-toggle="tooltip" title="" data-bs-original-title="Add Comments">
                                                <i className="feather-plus"></i>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="addNote" ref={addNoteRef} tabIndex="-1" aria-labelledby="addNote" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Not Ekle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body p-0">
                                <div className="px-3 w-100 d-flex border-bottom align-items-center">
                                    <input className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="Başlık" value={noteTitle} onChange={(e) => setNoteTitle(e.target.value)} />
                                </div>
                                <div className="px-3 w-100 d-flex align-items-center">
                                    <textarea className="form-control border-0 my-1 w-100 shadow-none" type="text" rows={3} placeholder="İçerik" value={noteDesc} onChange={(e) => setNoteDesc(e.target.value)}></textarea>
                                </div>
                            </div>

                            <div className="modal-footer d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="dropdown me-2">
                                        <a href="javascript:void(0)" onClick={createNote} className="btn btn-primary" data-bs-toggle="tooltip" data-bs-trigger="hover" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-plus"></i>
                                            </span>
                                            Ekle
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editAciklama" ref={editAciklamaRef} tabIndex="-1" aria-labelledby="editAciklama" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Açıklama Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <textarea
                                    className="form-control"
                                    rows={4}
                                    value={yeniAciklama}
                                    onChange={(e) => setYeniAciklama(e.target.value)}
                                    placeholder="Açıklama giriniz..."
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAciklamaUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editTemsilci" ref={editTemsilciRef} tabIndex="-1" aria-labelledby="editTemsilci" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Temsilci Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <select ref={temsilciSelectRef} className="form-control form-select">
                                    {temsilciler.map((temsilci) => {
                                        return <option key={"temsilci-" + temsilci.value} value={temsilci.value} selected={formData.Temsilci_ID === temsilci.value}>{temsilci.label}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={changeTemsilci}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="editReminder" ref={editReminderRef} tabIndex="-1" aria-labelledby="editReminder" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Hatırlatma Tarihi Düzenle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <input
                                class="form-control"
                                type="datetime-local"
                                value={reminderDate}
                                onChange={(e) => setReminderDate(e.target.value)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleReminderUpdate}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="addEtiket" ref={addEtiketRef} tabIndex="-1" aria-labelledby="addEtiket" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h2 className="d-flex flex-column mb-0">
                                    <span className="fs-18 fw-bold mb-1">Etiket Ekle</span>
                                </h2>
                                <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                    <i className="feather-x text-danger"></i>
                                </a>
                            </div>
                            <div className="modal-body">
                                <Select2WColor
                                    value={newEtiket}
                                    key={"etiket-" + formID}
                                    options={etiketler.filter(
                                        (etiket) => !formData.Etiketler.some(selected => selected.Etiket_ID === etiket.value)
                                    )}
                                    isSearchable={true}
                                    onChange={(e) => setNewEtiket(e)}
                                />
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >İptal</button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={addEtiket}
                                >Kaydet</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal fade-scale" id="viewNote" ref={viewNoteRef} tabIndex="-1" aria-labelledby="viewNote" aria-hidden="true" data-bs-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        {selectedNote && (
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h2 className="d-flex flex-column mb-0">
                                        <span className="fs-18 fw-bold mb-1">Not Ekle</span>
                                    </h2>
                                    <a href="javascript:void(0)" className="avatar-text avatar-md bg-soft-danger close-icon" data-bs-dismiss="modal">
                                        <i className="feather-x text-danger"></i>
                                    </a>
                                </div>
                                <div className="modal-body p-0">
                                    <div className="px-3 mt-3 w-100">
                                        <label className='form-label'>Not Başlığı</label>
                                        <input className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="Başlık" value={selectedNote.Not_Basligi} readOnly />
                                    </div>
                                    <div className="px-3 mt-3 w-100">
                                        <label className='form-label'>Not Açıklaması</label>
                                        <textarea id="viewNoteDesc" className="form-control border-0 my-1 w-100 shadow-none" type="text" placeholder="İçerik" value={selectedNote.Not_Aciklamasi} readOnly></textarea>
                                    </div>
                                </div>

                                <div className="modal-footer d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center gap-2">
                                        <a href="javascript:void(0)" className="btn btn-secondary" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="modal" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-x"></i>
                                            </span>
                                            Kapat
                                        </a>
                                        <a href="javascript:void(0)" className="btn btn-danger" onClick={(e) => deleteNote(selectedNote.Not_ID)} data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-dismiss="modal" title="" data-bs-original-title="Editing Actions">
                                            <span className="me-2">
                                                <i className="feather-trash-2"></i>
                                            </span>
                                            Sil
                                        </a>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </Layout>
    );
};

export default FormDetay;
